<template>
    <div>
        <CCard class="mob-pd-0px">
            <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
                <CRow class="flex-flow-column">
                    <CCol>
                        <strong>{{ $t("fareRule.title") }}</strong>
                    </CCol>

                    <p class="desc">{{ $t("fareRule.desc") }}</p>
                </CRow>
                <CButton
                        @click="navigateToNewFareRule(null)"
                        size="sm"
                        color="success"
                        class="ml-auto btn-lit-blue mob-w100"
                >{{ $t("fareRule.addFareRule") }}
                </CButton>
            </CCardHeader>
            <CAlert v-if="alertValue" show color="danger">
                <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                    <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
                </div>
                <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                    <span>{{$t("cAlert.errorCode")+' : '}}</span>
                    <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
                </div>
                <div v-if="alertValue&&alertValue.constructor==String">
                    <p>{{alertValue}}</p>
                </div>
            </CAlert>
            <CCardBody v-if="lsFareRule">
                  <!-- <br> -->
          <div class="d-flex"  v-if="GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode">
          <h3>{{$t("contract.contractName")+' : '}}</h3>  <h3 class="text-transform-uppercase"> {{GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode}}</h3>
           </div>
                             <br>

                   <cFullScreen>
          <template #fullScreen>
                <CRow class="max-width-550">
                    <CCol md="8">
                        <div v-if="selFareRule" class="d-flex justify-content-end">
            <span

                    @click="clearFareRuleSelection"
                    class="clear_statement mb-10px"
            >{{$t('agentDeposit.clear')}}</span>
                        </div>
                    </CCol>
                    <CCol md="4">

                    </CCol>
                </CRow>
                <div class="d-flex justify-content-between">
                    <CRow class="max-width-550 w-100">
                        <CCol md="8">

                            <multiselect
                                    v-model="selFareRule"
                                    label="farerule_code"
                                    :allow-empty="false"
                                    :options="lsFareRule"
                                    :track-by="'ruleid'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('fareRule.fareRulePl')"

                                    @input="onFareRuleChange"
                            >
                                <!-- :custom-label="fareRulePickCustomeLabel" -->
                                <!-- <template slot="singleLabel" slot-scope="{ option }">{{ option.farerule_code}}</template> -->

                                <template #noResult>
                                    <strong>{{$t('fareRule.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                        </CCol>

                        <CCol class="d-flex pb-2px" md="4">

                            <button @click="showCloneModal(null,true)"
                                    class="btn-lit-blue mob-w100 btn-success btn-sm f-14px d-flex text-center w-100 align-item-center justify-content-center">
                                {{$t('fareRule.cloneFareRule')}}
                            </button>
                        </CCol>


                    </CRow>
                    <!-- <div class="d-flex justify-end">

                            <div class="d-flex align-center justify-content-end fs-icon-wrap">


                                <img

                                     src="@imgPath/img/svg/icons/full_screen.svg"
                                     alt

                                     class="fullscreen-btn translatey-0px mr-0 "
                                     v-c-tooltip.hover="{ content:fullscreen?'Click to exit full screen':'Click to view in full screen' , active:false }"
                                />

                            </div>



                    </div> -->

                </div>
  <div class="page-controllers d-flex justify-content-between mt-20px" >
                        <div class="page-controller-wrap d-flex ">
                            <div class="d-flex align-item-center per-item">
                                <span class="align-item-center d-flex w-185px">{{$t('manageAgent.itemsPerPage')}}</span>
                                <select class="form-control " v-model="fareRuleWatchList.itemsPerPage">
                                    <option v-for="itemsPerPage in fareRuleWatchList.lsItemsPerPage" :key="itemsPerPage"
                                            :value="itemsPerPage">{{itemsPerPage}}
                                    </option>
                                </select>
                            </div>

                        </div>


                        <div class="d-flex align-item-center page-n">
                            <div class="mr-15px d-flex align-item-center">
                                <cPaginationLenOption :paginationWatchLs="fareRuleWatchList" class="d-flex align-item-center"/>
                            </div>
                            <CPagination
                                    :activePage.sync="fareRuleWatchList.currentPageNum"
                                    :pages="getTotalPages()"
                                    align="center"
                            />
                        </div>
                    </div>

                <div v-for="(fareRule,fareRuleIndex) in lsFareRule" :key="fareRuleIndex">
                    <div @click="navigateToNewFareRule(fareRule)" v-if="!selFareRule&&getFareRuleCountForView(fareRuleIndex)" class="card card assign pricing-card b-r-color ml-0 mr-0">
                        <div class="card-head d-flex ai-center bb-none">
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <div class="mr-10px">
                                    <h3 class="text-transform-uppercase"> {{fareRule.farerule_code}}</h3>
                                    <!--                                    <span>{{fareRule.farerule_desc}}</span>-->
                                </div>
                                <!--                                <span class="badge c-white badge-success">Active</span>-->
                            </div>
                            <div class="align-right d-flex"></div>
                        </div>
                        <div class="card-head d-flex ai-center justify-content-between d-flex pt-0px bb-none">
                            <div class="align-left a-name">
                                {{fareRule.farerule_desc}}
                                <div class="d-flex align-item-center">
                                    <strong class="mr-15px">
                                        {{$t('fareRule.advancePurchaseReq')}} :
                                    </strong>
                                    <div>
                                        {{$t('fareRule.allowThisFare',{beforeDays:fareRule.advance_purchase_on_or_before_days})}}
                                    </div>
                                </div>


                            </div>
                            <div class="button-wrap-r mt-auto">
                                <div class="row">

                                    
                                    <div class="col">
                                        <div col="2.5" size="sm" color="danger" class=" icon-25px c-pointer" @click.stop="showCloneModal(fareRule,false)"
                                             v-c-tooltip.hover="{ content:$t('fareRule.cloneTooltip') , active:false }">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img"
                                                 class="c-icon c-icon-lg" color="white">
                                                <path d="M22.125 0.75h-14.625c-0.621 0.001-1.124 0.504-1.125 1.125v14.625c0.001 0.621 0.504 1.124 1.125 1.125h14.625c0.621-0.001 1.124-0.504 1.125-1.125v-14.625c-0.001-0.621-0.504-1.124-1.125-1.125h-0zM21.75 16.125h-13.875v-13.875h13.875z"></path>
                                                <path d="M16.125 21.75h-13.875v-13.875h2.625v-1.5h-3c-0.621 0.001-1.124 0.504-1.125 1.125v14.625c0.001 0.621 0.504 1.124 1.125 1.125h14.625c0.621-0.001 1.124-0.504 1.125-1.125v-3h-1.5z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div col="2.5" color="info removewrap" class="edit-icon icon-25px c-pointer"     @click.stop="navigateToNewFareRule(fareRule)"
                                             v-if="permission&&permission.canEdit"  v-c-tooltip.hover="{ content: $t('fareRule.editTooltip') , active:false }">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="512pt" viewBox="0 0 512 512"
                                                 width="512pt" style="fill: rgb(60, 75, 100);">
                                                <path d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"></path>
                                                <path d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"></path>
                                                <path d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"></path>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div col="2.5" size="sm" color="danger" class=" icon-25px c-pointer"  v-if="permission&&permission.canDelete"
                                             @click.stop="showDeleteFareRuleModal(fareRule)"
                                             v-c-tooltip.hover="{ content: $t('fareRule.deleteTooltip') , active:false }">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img"
                                                 class="c-icon c-icon-lg"
                                                 style="color: rgb(205, 6, 6); font-size: 22px;">
                                                <path d="M4.5 22.125c-0 0.003-0 0.006-0 0.008 0 0.613 0.494 1.11 1.105 1.116h12.79c0.612-0.006 1.105-0.504 1.105-1.117 0-0.003-0-0.006-0-0.009v0-15h-15zM6 8.625h12v13.125h-12z"></path>
                                                <path d="M7.875 10.125h1.5v9.375h-1.5v-9.375z"></path>
                                                <path d="M11.25 10.125h1.5v9.375h-1.5v-9.375z"></path>
                                                <path d="M14.625 10.125h1.5v9.375h-1.5v-9.375z"></path>
                                                <path d="M15.375 4.125v-2.25c0-0.631-0.445-1.125-1.013-1.125h-4.725c-0.568 0-1.013 0.494-1.013 1.125v2.25h-5.625v1.5h18v-1.5zM10.125 2.25h3.75v1.875h-3.75z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


<!--                    <CCard v-if="!selFareRule" class="card assign pricing-card m-0 mt-15px">-->
<!--                        <CRow class="card-head d-flex ai-center">-->
<!--                            <CCol class="align-left a-name">-->
<!--                                <CRow>-->
<!--                                    <CCol>-->
<!--                                        <div class="w-100 d-flex justify-content-between">-->
<!--                                            <strong>Fare Rule Code</strong>-->
<!--                                            <strong>-->
<!--                                                :-->
<!--                                            </strong>-->
<!--                                        </div>-->

<!--                                    </CCol>-->
<!--                                    <CCol>-->
<!--                                        {{fareRule.farerule_code}}-->
<!--                                    </CCol>-->
<!--                                </CRow>-->
<!--                                <br/>-->
<!--                                <CRow>-->
<!--                                    <CCol>-->
<!--                                        <div class="w-100 d-flex justify-content-between">-->
<!--                                            <strong>Fare Rule Description</strong>-->
<!--                                            <strong>-->
<!--                                                :-->
<!--                                            </strong>-->
<!--                                        </div>-->

<!--                                    </CCol>-->
<!--                                    <CCol>-->
<!--                                        {{fareRule.farerule_desc}}-->
<!--                                    </CCol>-->
<!--                                </CRow>-->
<!--                                <br/>-->
<!--                                <CRow>-->
<!--                                    <CCol>-->
<!--                                        <div class="w-100 d-flex justify-content-between"><strong>{{$t('fareRule.advancePurchaseReq')}}</strong>-->
<!--                                            <strong>-->
<!--                                                :-->
<!--                                            </strong></div>-->
<!--                                    </CCol>-->
<!--                                    <CCol>-->
<!--                                        {{$t('fareRule.allowThisFare',{beforeDays:fareRule.advance_purchase_on_or_before_days})}}-->
<!--                                    </CCol>-->
<!--                                </CRow>-->
<!--                                &lt;!&ndash;                <br />&ndash;&gt;-->
<!--                                &lt;!&ndash;                <div>{{fareRule.farerule_code}}</div>&ndash;&gt;-->
<!--                                &lt;!&ndash;                <br />&ndash;&gt;-->
<!--                                &lt;!&ndash;                <div>{{fareRule.farerule_desc}}</div>&ndash;&gt;-->
<!--                                &lt;!&ndash;                <br />&ndash;&gt;-->
<!--                                &lt;!&ndash;                <div><strong>{{$t('fareRule.advancePurchaseReq')+' : '}}</strong>{{$t('fareRule.allowThisFare',{beforeDays:fareRule.advance_purchase_on_or_before_days})}}</div>&ndash;&gt;-->
<!--                                &lt;!&ndash;                <br />&ndash;&gt;-->
<!--                            </CCol>-->
<!--                            <CCol class="align-right">-->
<!--                                <div class="max-w-200px ml-auto">-->
<!--                                    <CRow class="justify-content-around">-->
<!--                                        <div-->
<!--                                                v-if="permission&&permission.canDelete"-->
<!--                                                @click.stop="showDeleteFareRuleModal(fareRule)"-->
<!--                                                class="c-red c-pointer w-23px h-23px svg-w-100"-->
<!--                                                v-c-tooltip.hover="{ content: $t('fareRule.deleteTooltip') , active:false }"-->
<!--                                        >-->
<!--                                            <CIcon color="#cd0606" name="cil-trash" size="lg"/>-->
<!--                                        </div>-->
<!--                                        <div-->
<!--                                                @click.stop="showCloneModal(fareRule,false)"-->
<!--                                                v-c-tooltip.hover="{ content:$t('fareRule.cloneTooltip') , active:false }"-->
<!--                                                class="c-pointer w-23px h-23px svg-w-100"-->
<!--                                        >-->
<!--                                            <CIcon-->

<!--                                                    color="white"-->
<!--                                                    name="cil-clone"-->
<!--                                                    size="lg"-->
<!--                                            />-->
<!--                                        </div>-->
<!--                                        <div class="right-align d-flex">-->
<!--                                            <div-->
<!--                                                    @click.stop="navigateToNewFareRule(fareRule)"-->
<!--                                                    v-if="permission&&permission.canEdit"-->
<!--                                                    class="edit-icon c-pointer"-->
<!--                                                    color="info removewrap"-->
<!--                                                    v-c-tooltip.hover="{ content: $t('fareRule.editTooltip') , active:false }"-->
<!--                                            >-->
<!--                                                <svg-->
<!--                                                        xmlns="http://www.w3.org/2000/svg"-->
<!--                                                        height="512pt"-->
<!--                                                        viewBox="0 0 512 512"-->
<!--                                                        width="512pt"-->
<!--                                                        style="fill:#3c4b64;"-->
<!--                                                >-->
<!--                                                    <path-->
<!--                                                            d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"-->
<!--                                                    />-->
<!--                                                    <path-->
<!--                                                            d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"-->
<!--                                                    />-->
<!--                                                    <path-->
<!--                                                            d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"-->
<!--                                                    />-->
<!--                                                </svg>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </CRow>-->
<!--                                </div>-->
<!--                            </CCol>-->
<!--                        </CRow>-->
<!--                    </CCard>-->
                </div>
                <div @click="navigateToNewFareRule(selFareRule)" v-if="selFareRule" class="card card assign pricing-card b-r-color ml-0 mr-0 b-r-color">
                    <div class="card-head d-flex ai-center bb-none">
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="mr-10px">
                                <h3 class="text-transform-uppercase"> {{selFareRule.farerule_code}}</h3>
                                <!--                                    <span>{{fareRule.farerule_desc}}</span>-->
                            </div>
                            <!--                                <span class="badge c-white badge-success">Active</span>-->
                        </div>
                        <div class="align-right d-flex"></div>
                    </div>
                    <div class="card-head d-flex ai-center justify-content-between d-flex pt-0px bb-none">
                        <div class="align-left a-name">
                            {{selFareRule.farerule_desc}}
                            <div class="d-flex align-item-center">
                                <strong class="mr-15px">
                                    {{$t('fareRule.advancePurchaseReq')}} :
                                </strong>
                                <div>
                                    {{$t('fareRule.allowThisFare',{beforeDays:selFareRule.advance_purchase_on_or_before_days})}}
                                </div>
                            </div>


                        </div>
                        <div class="button-wrap-r mt-auto">
                            <div class="row">

                               
                                <div class="col">
                                    <div col="2.5" size="sm" color="danger" class=" icon-25px c-pointer" @click.stop="showCloneModal(selFareRule,false)">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img"
                                             class="c-icon c-icon-lg" color="white">
                                            <path d="M22.125 0.75h-14.625c-0.621 0.001-1.124 0.504-1.125 1.125v14.625c0.001 0.621 0.504 1.124 1.125 1.125h14.625c0.621-0.001 1.124-0.504 1.125-1.125v-14.625c-0.001-0.621-0.504-1.124-1.125-1.125h-0zM21.75 16.125h-13.875v-13.875h13.875z"></path>
                                            <path d="M16.125 21.75h-13.875v-13.875h2.625v-1.5h-3c-0.621 0.001-1.124 0.504-1.125 1.125v14.625c0.001 0.621 0.504 1.124 1.125 1.125h14.625c0.621-0.001 1.124-0.504 1.125-1.125v-3h-1.5z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="col">
                                    <div col="2.5" color="info removewrap" class="edit-icon icon-25px c-pointer" @click.stop="navigateToNewFareRule(selFareRule)"
                                         v-if="permission&&permission.canEdit">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="512pt" viewBox="0 0 512 512"
                                             width="512pt" style="fill: rgb(60, 75, 100);">
                                            <path d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"></path>
                                            <path d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"></path>
                                            <path d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"></path>
                                        </svg>
                                    </div>
                                </div>
                                 <div class="col">
                                    <div col="2.5" size="sm" color="danger" class=" icon-25px c-pointer" v-if="permission&&permission.canDelete"
                                         @click.stop="showDeleteFareRuleModal(selFareRule)">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img"
                                             class="c-icon c-icon-lg"
                                             style="color: rgb(205, 6, 6); font-size: 22px;">
                                            <path d="M4.5 22.125c-0 0.003-0 0.006-0 0.008 0 0.613 0.494 1.11 1.105 1.116h12.79c0.612-0.006 1.105-0.504 1.105-1.117 0-0.003-0-0.006-0-0.009v0-15h-15zM6 8.625h12v13.125h-12z"></path>
                                            <path d="M7.875 10.125h1.5v9.375h-1.5v-9.375z"></path>
                                            <path d="M11.25 10.125h1.5v9.375h-1.5v-9.375z"></path>
                                            <path d="M14.625 10.125h1.5v9.375h-1.5v-9.375z"></path>
                                            <path d="M15.375 4.125v-2.25c0-0.631-0.445-1.125-1.013-1.125h-4.725c-0.568 0-1.013 0.494-1.013 1.125v2.25h-5.625v1.5h18v-1.5zM10.125 2.25h3.75v1.875h-3.75z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


<!--                <CCard v-if="selFareRule" class=" card assign pricing-card m-0 mt-15px">-->

<!--                    <CRow class="card-head d-flex ai-center">-->
<!--                        <CCol class="align-left a-name">-->
<!--                            <CRow>-->
<!--                                <CCol>-->
<!--                                    <div class="w-100 d-flex justify-content-between">-->
<!--                                        <strong>Fare Rule Code</strong>-->
<!--                                        <strong>-->
<!--                                            :-->
<!--                                        </strong>-->
<!--                                    </div>-->

<!--                                </CCol>-->
<!--                                <CCol>-->
<!--                                    {{selFareRule.farerule_code}}-->
<!--                                </CCol>-->
<!--                            </CRow>-->
<!--                            <br/>-->
<!--                            <CRow>-->
<!--                                <CCol>-->
<!--                                    <div class="w-100 d-flex justify-content-between">-->
<!--                                        <strong>Fare Rule Description</strong>-->
<!--                                        <strong>-->
<!--                                            :-->
<!--                                        </strong>-->
<!--                                    </div>-->

<!--                                </CCol>-->
<!--                                <CCol>-->
<!--                                    {{selFareRule.farerule_desc}}-->
<!--                                </CCol>-->
<!--                            </CRow>-->
<!--                            <br/>-->
<!--                            <CRow>-->
<!--                                <CCol>-->
<!--                                    <div class="w-100 d-flex justify-content-between"><strong>{{$t('fareRule.advancePurchaseReq')}}</strong>-->
<!--                                        <strong>-->
<!--                                            :-->
<!--                                        </strong></div>-->
<!--                                </CCol>-->
<!--                                <CCol>-->
<!--                                    {{$t('fareRule.allowThisFare',{beforeDays:selFareRule.advance_purchase_on_or_before_days})}}-->
<!--                                </CCol>-->
<!--                            </CRow>-->
<!--                            &lt;!&ndash;                <br />&ndash;&gt;-->
<!--                            &lt;!&ndash;                <div>{{fareRule.farerule_code}}</div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                <br />&ndash;&gt;-->
<!--                            &lt;!&ndash;                <div>{{fareRule.farerule_desc}}</div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                <br />&ndash;&gt;-->
<!--                            &lt;!&ndash;                <div><strong>{{$t('fareRule.advancePurchaseReq')+' : '}}</strong>{{$t('fareRule.allowThisFare',{beforeDays:fareRule.advance_purchase_on_or_before_days})}}</div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                <br />&ndash;&gt;-->
<!--                        </CCol>-->

<!--                        <CCol class="align-right">-->
<!--                            <div class="max-w-200px ml-auto">-->
<!--                                <CRow class="justify-content-around">-->
<!--                                    <div-->
<!--                                            v-if="permission&&permission.canDelete"-->
<!--                                            @click.stop="showDeleteFareRuleModal(selFareRule)"-->
<!--                                            class="c-red c-pointer w-23px h-23px svg-w-100"-->
<!--                                            v-c-tooltip.hover="{ content:  $t('fareRule.deleteTooltip') , active:false }"-->
<!--                                    >-->
<!--                                        <CIcon color="#cd0606" name="cil-trash" size="lg"/>-->
<!--                                    </div>-->
<!--                                    <div-->
<!--                                            @click.stop="showCloneModal(selFareRule,false)"-->
<!--                                            v-c-tooltip.hover="{ content: $t('fareRule.cloneTooltip')  , active:false }"-->
<!--                                            class="c-pointer w-23px h-23px svg-w-100"-->
<!--                                    >-->
<!--                                        <CIcon-->

<!--                                                color="white"-->
<!--                                                name="cil-clone"-->
<!--                                                size="lg"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="right-align d-flex">-->
<!--                                        <div-->
<!--                                                @click.stop="navigateToNewFareRule(selFareRule)"-->
<!--                                                v-if="permission&&permission.canEdit"-->
<!--                                                class="edit-icon c-pointer"-->
<!--                                                color="info removewrap"-->
<!--                                                v-c-tooltip.hover="{ content: $t('fareRule.editTooltip') , active:false }"-->
<!--                                        >-->
<!--                                            <svg-->
<!--                                                    xmlns="http://www.w3.org/2000/svg"-->
<!--                                                    height="512pt"-->
<!--                                                    viewBox="0 0 512 512"-->
<!--                                                    width="512pt"-->
<!--                                                    style="fill:#3c4b64;"-->
<!--                                            >-->
<!--                                                <path-->
<!--                                                        d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"-->
<!--                                                />-->
<!--                                                <path-->
<!--                                                        d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"-->
<!--                                                />-->
<!--                                                <path-->
<!--                                                        d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"-->
<!--                                                />-->
<!--                                            </svg>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </CRow>-->
<!--                            </div>-->
<!--                        </CCol>-->


<!--                    </CRow>-->


<!--                    &lt;!&ndash;          <CRow class="card-head d-flex ai-center">&ndash;&gt;-->
<!--                    &lt;!&ndash;            <CCol class="align-left a-name">&ndash;&gt;-->
<!--                    &lt;!&ndash;              <br />&ndash;&gt;-->
<!--                    &lt;!&ndash;              <div>{{selFareRule.farerule_code}}</div>&ndash;&gt;-->
<!--                    &lt;!&ndash;              <br />&ndash;&gt;-->
<!--                    &lt;!&ndash;              <div>{{selFareRule.farerule_desc}}</div>&ndash;&gt;-->
<!--                    &lt;!&ndash;              <br />&ndash;&gt;-->
<!--                    &lt;!&ndash;           &ndash;&gt;-->
<!--                    &lt;!&ndash;               <div><strong>{{$t('fareRule.advancePurchaseReq')+' : '}}</strong>{{$t('fareRule.allowThisFare',{beforeDays:selFareRule.advance_purchase_on_or_before_days})}}</div>&ndash;&gt;-->
<!--                    &lt;!&ndash;              <br />&ndash;&gt;-->
<!--                    &lt;!&ndash;            </CCol>&ndash;&gt;-->
<!--                    &lt;!&ndash;            <CCol class="align-right">&ndash;&gt;-->
<!--                    &lt;!&ndash;              <div>&ndash;&gt;-->
<!--                    &lt;!&ndash;                <CRow>&ndash;&gt;-->
<!--                    &lt;!&ndash;                  <div&ndash;&gt;-->
<!--                    &lt;!&ndash;                    v-if="permission&&permission.canDelete"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    @click.stop="showDeleteFareRuleModal(selFareRule)"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    class="c-red w-23px h-23px svg-w-100"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    v-c-tooltip.hover="{ content:  $t('fareRule.deleteTooltip') , active:false }"&ndash;&gt;-->
<!--                    &lt;!&ndash;                  >&ndash;&gt;-->
<!--                    &lt;!&ndash;                    <CIcon color="#cd0606" name="cil-trash" size="lg" />&ndash;&gt;-->
<!--                    &lt;!&ndash;                  </div>&ndash;&gt;-->

<!--                    &lt;!&ndash;                  <div&ndash;&gt;-->
<!--                    &lt;!&ndash;                    @click.stop="showCloneModal(selFareRule,false)" class="w-23px h-23px svg-w-100"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    v-c-tooltip.hover="{ content: $t('fareRule.cloneTooltip')  , active:false }"&ndash;&gt;-->
<!--                    &lt;!&ndash;                  >&ndash;&gt;-->
<!--                    &lt;!&ndash;                    <CIcon&ndash;&gt;-->
<!--                    &lt;!&ndash;                     &ndash;&gt;-->
<!--                    &lt;!&ndash;                      color="white"&ndash;&gt;-->
<!--                    &lt;!&ndash;                      name="cil-clone"&ndash;&gt;-->
<!--                    &lt;!&ndash;                      size="lg"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    />&ndash;&gt;-->
<!--                    &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--                    &lt;!&ndash;                  <div class="right-align d-flex">&ndash;&gt;-->
<!--                    &lt;!&ndash;                    <div&ndash;&gt;-->
<!--                    &lt;!&ndash;                      @click.stop="navigateToNewFareRule(selFareRule)"&ndash;&gt;-->
<!--                    &lt;!&ndash;                      v-if="permission&&permission.canEdit"&ndash;&gt;-->
<!--                    &lt;!&ndash;                      class="edit-icon"&ndash;&gt;-->
<!--                    &lt;!&ndash;                      color="info removewrap"&ndash;&gt;-->
<!--                    &lt;!&ndash;                      v-c-tooltip.hover="{ content: $t('fareRule.editTooltip') , active:false }"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    >&ndash;&gt;-->
<!--                    &lt;!&ndash;                      <svg&ndash;&gt;-->
<!--                    &lt;!&ndash;                        xmlns="http://www.w3.org/2000/svg"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        height="512pt"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        viewBox="0 0 512 512"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        width="512pt"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        style="fill:#3c4b64;"&ndash;&gt;-->
<!--                    &lt;!&ndash;                      >&ndash;&gt;-->
<!--                    &lt;!&ndash;                        <path&ndash;&gt;-->
<!--                    &lt;!&ndash;                          d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        />&ndash;&gt;-->
<!--                    &lt;!&ndash;                        <path&ndash;&gt;-->
<!--                    &lt;!&ndash;                          d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        />&ndash;&gt;-->
<!--                    &lt;!&ndash;                        <path&ndash;&gt;-->
<!--                    &lt;!&ndash;                          d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        />&ndash;&gt;-->
<!--                    &lt;!&ndash;                      </svg>&ndash;&gt;-->
<!--                    &lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                    &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--                    &lt;!&ndash;                </CRow>&ndash;&gt;-->
<!--                    &lt;!&ndash;              </div>&ndash;&gt;-->
<!--                    &lt;!&ndash;            </CCol>&ndash;&gt;-->
<!--                    &lt;!&ndash;          </CRow>&ndash;&gt;-->
<!--                </CCard>-->
                <CRow>

                </CRow>
                <CRow>

                </CRow>
   </template>
       </cFullScreen>
                <!-- table filter hidded
                tableFilter-->
                <!-- <button class="mf-success-round-btn">Apply</button> -->
            </CCardBody>
            <CCardFooter>
                <div class="d-flex justify-content-end">
                    <div class="d-flex justify-content-between mr-auto">
                        <CButton
                                @click="navigateToContract"
                                size="sm"
                                color="danger"
                                class="action-c-btn"
                        >{{ $t("fareRule.goBack") }}
                        </CButton>
                    </div>
                </div>

            </CCardFooter>
        </CCard>

        <CModal v-if=" isCloneModal"
                     :closeOnBackdrop="false"
                :show.sync="isCloneModal"
                :centered="true"
                size="lg"
                :title="$t('fareRule.cloneFareRule')"
        >
            <template>
                <div v-if="isCloneWithContract">
                    <ValidationObserver v-slot="{ handleSubmit }">

                        <label>
                            {{$t('fareRule.contractCode')}}
                        </label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                           
                            <multiselect

                                  
                                    :track-by="'contractid'"
                               :label="'contractcode'"                          
                             v-model="selectedContract"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    :options="GET_ALL_CONTRACT_RES"
                                    :placeholder="$t('fareRule.contractCodePl')"
                                    @input="onContractChange"
                            >
                                <template slot="option" slot-scope="props">
                                    <div class="d-flex">
                                        <span>{{ props.option['contractcode'] }}</span>
                                        <!-- <strong class="right ml-auto">
                                                            {{
                                                            props.option['contractcode']
                                                            }}
                                        </strong>-->
                                    </div>
                                </template>
                                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                        <br />
                        <label>
                            {{$t('fareRule.fareRule')}}
                        </label>
                        <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <multiselect
                                    v-model="selFareRule"
                                    label="farerule_code"
                                    :allow-empty="false"
                                    :options="lsFareRuleOpt"
                                    :track-by="'ruleid'"
                                    deselectLabel
                                    deselectGroupLabel
                                    selectLabel
                                    selectedLabel
                                    :placeholder="$t('fareRule.fareRulePl')"

                                    @input="onFareRuleChange"
                            >


                                <template #noResult>
                                    <strong>{{$t('fareRule.listEmpty')}}</strong>
                                </template>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                        <br />
                        <label>{{$t('fareRule.newFareRuleCode')}}</label>
                        <div>
                            <cTextInputComponent
                                    v-model="newRuleCode"
                                    :placeholder="$t('fareRule.newFareRuleCodePl')"
                                    rules="required|noSpaceAndSpl|minimum:3|max:30"
                                    class="inner-label-none mr-10px w-100"
                            />
                            <br />
                            <button @click.prevent="handleSubmit(showCloneConfirmation)" class="btn ml-auto btn-lit-blue mob-w100 btn-success btn-sm min-w-150">{{$t('fareRule.cloneBtn')}}
                            </button>
                        </div>


                    </ValidationObserver>
                </div>
                <div v-else>
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <!--                             <label>{{$t('fareRule.newFareRuleCode')}}</label>-->
                        <div class="">
                            <cTextInputComponent
                                    v-model="newRuleCode"
                                    :placeholder="$t('fareRule.newFareRuleCodePl')"
                                    rules="required|noSpaceAndSpl|minimum:3|max:30"
                                    :label="$t('fareRule.newFareRuleCode')"
                                    class="w-100"
                            />
                            <br />
                            <button @click.prevent="handleSubmit(showCloneConfirmation)"
                                    class="btn ml-auto btn-lit-blue mob-w100 btn-success btn-sm mt-0 mb-2px min-w-150">
                                {{$t('fareRule.cloneBtn')}}
                            </button>
                        </div>
                    </ValidationObserver>

                </div>


            </template>

            <template #footer-wrapper>
                <div></div>
            </template>
        </CModal>

        <cAlertModal
                v-if="isCloneConfmModal"
                :buttonList="[{
              name:$t('fareRule.noBtn'),func:onHideConfirmationModals,color:'danger'},
                {name:$t('fareRule.yesBtn'),func:onCloneFareRule,color:'success'},]"
                :status="2"
                :show="isCloneConfmModal"
                :desc="$t('fareRule.cloneFRConfirmation')"
        ></cAlertModal>
        <cAlertModal
                v-if="isDeleteFRConfirmation"
                :buttonList="[{
              name:$t('fareRule.noBtn'),func:onHideConfirmationModals,color:'danger'},
                {name:$t('fareRule.yesBtn'),func:onDeleteFareRule,color:'success'},]"
                :status="2"
                :show="isDeleteFRConfirmation"
                :desc="$t('fareRule.deleteFRConfirmation')"
        ></cAlertModal>
        <cAlertModal
                v-if="isFRCloned"
                :buttonList="[{name:$t('fareRule.okBtn'),func:onHideConfirmationModals,color:'success'}]"
                :status="1"
                :show="isFRCloned"
                :desc="$t('fareRule.fRClonedSuccDesc')"
        ></cAlertModal>
        <cAlertModal
                v-if="isFareRuleDeleted"
                :buttonList="[{name:$t('fareRule.okBtn'),func:onHideConfirmationModals,color:'success'}]"
                :status="1"
                :show="isFareRuleDeleted"
                :desc="$t('fareRule.deleteFRSuccDesc')"
        ></cAlertModal>
        <cAlertModal
                v-if="isFailedModal"
                :buttonList="[{name:$t('scheduleAll.okBtn'),func:onHideConfirmationModals,color:'danger'}]"
                :status="0"
                :show="isFailedModal"
                :desc="alertValue"
        ></cAlertModal>
    </div>
</template>

<script>
    import router, {navigate} from "../../../../router/index";

    import {mapGetters, mapActions} from "vuex";
    import {
        PATHNAME,
        COMPONENT_NAME,
        DEFAULT_DROPDOWN_STATUS,
        ORDER
    } from "../../../../util/constants";
    import Logger from "../../../../services/logger";
    import SERVICE_URL, {
        FILE_NAME,
        LOG_TYPE,
        HTTP_CODES
    } from "../../../../config/API_DATA";
    import multiselect from "vue-multiselect";
    import {
        VALIDATE_SUCCESS_RES,
        getErrorMessage
    } from "../../../../util/apiValidate";
    import {
        handleJWT,
        getErrorAlertValue,
        addClassToBody,
        removeClassBody,
        OrderByList,
        cloneData
    } from "../../../../util/util";
    import BaseConfiguration from "../../../../config/base.js";
    import apiGetFareRule from "../../../../services/apiGetFareRule";
    import cAlertModal from "../../../../components/form/cAlertModal";
    import apiCloneFareRule from "../../../../services/apiCloneFareRule";
    import cTextInputComponent from "../../../../components/form/cTextInputComponent";
    import {ValidationObserver, ValidationProvider, localize} from "vee-validate";
    // import nb from "../../../../translations/validation/nb.json";
    // import en from "../../../../translations/validation/en.json";
    import apiDeleteFareRule from "../../../../services/apiDeleteFareRule";
    import cPaginationLenOption from "../../../../components/dataTable/cPaginationLenOption";
import cFullScreen from "../../../../components/cFullScreen";


    // localize({
    //   en: {
    //     messages: en.messages
    //   },
    //   nb: {
    //     messages: nb.messages
    //   }
    // });
    export default {
        name: COMPONENT_NAME.FARE_RULE_ALL,
        components: {
            multiselect,
            cAlertModal,
            cTextInputComponent,
            ValidationObserver,
            ValidationProvider,
            cPaginationLenOption,
            cFullScreen
        },

        data: () => {
            return {
                lsFareRuleOpt: null,
                lsFareRule: null,
                alertValue: null,
                selFareRule: null,
                permission: null,
                isDeleteFRConfirmation: false,
                isCloneConfmModal: false,
                isFRCloned: false,
                isFareRuleDeleted: false,
                isFailedModal: false,
                newRuleCode: null,
                isCloneModal: false,
                isCloneWithContract: false,
                selectedContract: null,
                fareRuleWatchList: {
                    filteredlistCount: null,
                    itemsPerPage: 25,
                    currentPageNum: 1,
                    lsItemsPerPage: [5, 10, 15, 25]
                },

            };
        },
        watch: {
            lsFareRule: {
                immediate: false,
                deep: true,
                handler: function (newVal, oldVal) {


                    this.fareRuleWatchList.filteredlistCount = this.lsFareRule.length;


                },
            }

        },


        methods: {
            ...mapActions("sFlightSchedule", {
                SET_SEL_FLIGHT_SCHEDULE: "SET_SEL_FLIGHT_SCHEDULE"
            }),
            ...mapActions("sContract", ["SET_SELECTED_CONTRACT"]),


            fareRulePickCustomeLabel(option) {
                return `${option.ruleid}`;
            },
            getTotalPages() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getTotalPages");
                    if (this.fareRuleWatchList.filteredlistCount != null) {
                        let totalPages = this.fareRuleWatchList.filteredlistCount / this.fareRuleWatchList.itemsPerPage;
                        retValue = Math.ceil(totalPages);


                        if (retValue <= 0) {
                            retValue = 1;
                        }
                    } else {
                        retValue = 1;
                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                          COMPONENT_NAME.FARE_RULE_ALL,
                        "error in getTotalPages",
                        err.toString(),
                        "getTotalPages",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getStartValueCount() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getStartValueCount");
                    if (this.fareRuleWatchList.filteredlistCount == 0) {
                        retValue = 0;
                    } else {
                        if (
                            this.fareRuleWatchList.itemsPerPage <
                            this.fareRuleWatchList.filteredlistCount
                        ) {
                            retValue =
                                (this.fareRuleWatchList.currentPageNum - 1) *
                                this.fareRuleWatchList.itemsPerPage;
                            retValue = retValue + 1;
                        } else {
                            retValue = 1;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                          COMPONENT_NAME.FARE_RULE_ALL,
                        "error in getStartValueCount",
                        err.toString(),
                        "getStartValueCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getFareRuleCountForView(pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getFareRuleCountForView");
                    let count = 0;


                    count = pIndex + 1;


                    if (count >= this.getStartValueCount() && count <= this.getFilteredListPerPage()) {
                        return true;
                    } else {
                        return false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                          COMPONENT_NAME.FARE_RULE_ALL,
                        "error in getFareRuleCountForView",
                        err.toString(),
                        "getFareRuleCountForView",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            getFilteredListPerPage() {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getFilteredListPerPage");
                    if (
                        this.fareRuleWatchList.itemsPerPage <
                        this.fareRuleWatchList.filteredlistCount
                    ) {
                        if (
                            this.fareRuleWatchList.currentPageNum *
                            this.fareRuleWatchList.itemsPerPage >
                            this.fareRuleWatchList.filteredlistCount
                        ) {
                            retValue = this.fareRuleWatchList.filteredlistCount;
                        } else {
                            retValue =
                                this.fareRuleWatchList.currentPageNum *
                                this.fareRuleWatchList.itemsPerPage;
                        }
                    } else {
                        retValue = this.fareRuleWatchList.filteredlistCount;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                          COMPONENT_NAME.FARE_RULE_ALL,
                        "error in getFilteredListPerPage",
                        err.toString(),
                        "getFilteredListPerPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            navigateToContract() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navigateToContract");

                    navigate(PATHNAME.CONTRACT_ALL);
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in navigateToContract",
                        err.toString(),
                        "navigateToContract",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            navigateToNewFareRule(pItem) {
                try {
                    if (BaseConfiguration.isDebug) console.log("navigateToNewFareRule");
                    this.SET_SEL_FLIGHT_SCHEDULE(pItem);
                    navigate(PATHNAME.FARE_RULE_NEW);
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in navigateToNewFareRule",
                        err.toString(),
                        "navigateToNewFareRule",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            onHideConfirmationModals() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onHideConfirmationModals");

                    this.isCloneConfmModal = false;
                    this.isDeleteFRConfirmation = false;
                    this.isFRCloned = false;
                    this.isFailedModal = false;
                    this.isFareRuleDeleted = false;
                    this.newRuleCode = null;
                    this.selFareRule = null;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in onHideConfirmationModals",
                        err.toString(),
                        "onHideConfirmationModals",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            showDeleteFareRuleModal(pItem) {
                try {
                    if (BaseConfiguration.isDebug) console.log("showDeleteFareRuleModal");
                    this.selFareRule = pItem;
                    this.isDeleteFRConfirmation = true;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in showDeleteFareRuleModal",
                        err.toString(),
                        "showDeleteFareRuleModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            showCloneConfirmation() {
                try {
                    if (BaseConfiguration.isDebug) console.log("showCloneConfirmation");
                    // this.selFareRule = pItem;
                    this.isCloneModal = false;
                    this.isCloneConfmModal = true;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in showCloneConfirmation",
                        err.toString(),
                        "showCloneConfirmation",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            showCloneModal(pItem, pIsContract) {
                try {
                    if (BaseConfiguration.isDebug) console.log("showCloneConfirmation");
                    this.selFareRule = pItem;
                    this.isCloneModal = true;
                    this.isCloneWithContract = pIsContract;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in showCloneConfirmation",
                        err.toString(),
                        "showCloneConfirmation",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            clearFareRuleSelection() {
                try {
                    if (BaseConfiguration.isDebug) console.log("clearFareRuleSelection");
                    this.selFareRule = null;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in clearFareRuleSelection",
                        err.toString(),
                        "clearFareRuleSelection",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async onContractChange(pSelContract) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onContractChange");
                    let contractId = pSelContract
                        ? pSelContract.contractid
                        : null;
                        this.lsFareRuleOpt = await this.getFareRules(contractId);
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in onContractChange",
                        err.toString(),
                        "onContractChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            

            onFareRuleChange(pSelFareRule) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onFareRuleChange");
                    this.selFareRule = pSelFareRule;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in onFareRuleChange",
                        err.toString(),
                        "onFareRuleChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            async onCloneFareRule() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onCloneFareRule");
                    let cloneReq = {
                        "ruleId": Number(this.selFareRule.ruleid),
                        "newRuleCode": this.newRuleCode,
                        "contract": this.GET_SELECTED_CONTRACT
                        ? this.GET_SELECTED_CONTRACT.contractid
                        : null
                        // this.selectedContract && this.selectedContract.contractid ?
                        //  Number(this.selectedContract.contractid) : null
                    }
                    let isCloned = await this.cloneFareRule(cloneReq);
                    this.isCloneConfmModal = false;
                    if (isCloned) {
                        let contractId = this.GET_SELECTED_CONTRACT
                        ? this.GET_SELECTED_CONTRACT.contractid
                        : null;
                        let lsFareRule = await this.getFareRules(contractId);
                        if (lsFareRule) {
                            this.lsFareRule = lsFareRule;
                        }
                        this.isFRCloned = true;
                    } else {
                        this.isFailedModal = true;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.SCHEDULE_ALL,
                        "error in onCloneFareRule",
                        err.toString(),
                        "onCloneFareRule",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            async onDeleteFareRule() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onDeleteFareRule");
                    let ruleId =
                        this.selFareRule && this.selFareRule.ruleid
                            ? this.selFareRule.ruleid
                            : null;
                    let isDeleted = await this.deleteFlightSchedule(ruleId);
                    this.isDeleteFRConfirmation = false;
                    if (isDeleted) {
                        let contractId = this.GET_SELECTED_CONTRACT
                        ? this.GET_SELECTED_CONTRACT.contractid
                        : null;
                        let lsFareRule = await this.getFareRules(contractId);
                        if (lsFareRule) {
                            this.lsFareRule = lsFareRule;
                        }
                        this.isFareRuleDeleted = true;
                    } else {
                        this.isFailedModal = true;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.SCHEDULE_ALL,
                        "error in onDeleteFareRule",
                        err.toString(),
                        "onDeleteFareRule",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            async deleteFlightSchedule(pRuleId) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("deleteFlightSchedule");

                    let fareRuleReq = apiDeleteFareRule.buildRequest(
                        pRuleId
                    );

                    if (fareRuleReq) {
                        let flightScheduleRes = await apiDeleteFareRule.getResponse(
                            fareRuleReq
                        );
                        if (VALIDATE_SUCCESS_RES(flightScheduleRes)) {
                            this.alertValue = null;
                            retValue = flightScheduleRes.data.data.isDeleted;
                            // this.showAcknowledgeAlert();
                        } else {
                            let error = getErrorMessage(flightScheduleRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.SCHEDULE_ALL,
                        "error in deleteFlightSchedule",
                        err.toString(),
                        "deleteFlightSchedule",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            async cloneFareRule(pCloneReq) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("cloneFareRule");

                    let fareRuleReq = apiCloneFareRule.buildRequest(
                        pCloneReq
                    );

                    if (fareRuleReq) {
                        let flightScheduleRes = await apiCloneFareRule.getResponse(
                            fareRuleReq
                        );
                        if (VALIDATE_SUCCESS_RES(flightScheduleRes)) {
                            this.alertValue = null;
                            retValue = flightScheduleRes.data.data;
                            // this.showAcknowledgeAlert();
                        } else {
                            let error = getErrorMessage(flightScheduleRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.SCHEDULE_ALL,
                        "error in cloneFareRule",
                        err.toString(),
                        "cloneFareRule",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            async getFareRules(contractId) {
                if (BaseConfiguration.isDebug) console.log("getFareRules");
                let returnValue;
                try {
                    // let contractId = this.GET_SELECTED_CONTRACT
                    //     ? this.GET_SELECTED_CONTRACT.contractid
                    //     : null;
                    let fareRuleReq = apiGetFareRule.buildRequest(contractId);

                    if (fareRuleReq != null) {
                        let fareRuleRes = await apiGetFareRule.getResponse(fareRuleReq);
                        if (VALIDATE_SUCCESS_RES(fareRuleRes)) {
                            this.alertValue = null;
                            returnValue = fareRuleRes.data.data.FlightFareList;
                            this.permission = fareRuleRes.data.data.permission;
                        } else {
                            let error = getErrorMessage(fareRuleRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.FARE_RULE_ALL,
                        "error in  getFareRules",
                        err.toString(),
                        "getFareRules",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },

        },

        async created() {
            try {
                let contractId = this.GET_SELECTED_CONTRACT
                        ? this.GET_SELECTED_CONTRACT.contractid
                        : null;
                this.lsFareRule = await this.getFareRules(contractId);
                this.lsFareRuleOpt = this.lsFareRule
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.FARE_RULE_ALL,
                    "error in  Created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },
        computed: {
            ...mapGetters("sContract", {
                GET_SELECTED_CONTRACT: "GET_SELECTED_CONTRACT",
                GET_ALL_CONTRACT_RES: "GET_ALL_CONTRACT_RES"
            })
        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.FARE_RULE_ALL);
        },

        beforeDestroy() {
            removeClassBody();
        }
    };
</script>
